<template>
  <div class="carousel-frame">
    <carousel
        v-if="images.length > 0"
      ref="c"
      :per-page="1"
      :loop="false"
      :navigation-enabled="false"
      :pagination-enabled="false" 
      :mouse-drag="true"
      :touch-drag="true"
      :adjustable-height="false"
      @page-change="onPageChange"   
      @page-change-start="onPageChangeStart"  
    >
        <slide v-for="(img, i) in images" :key="i">
            <div class="image-box">
            <img :src="img.url" alt="" draggable="false" />
            </div>
        </slide>
    </carousel>
    <img class="default-image" v-else src="../../assets/default_hospital_image.png" />

    <!-- 커스텀 dots -->
    <div class="dots"  v-if="images.length > 0">
      <button
        v-for="(img, i) in images"
        :key="i"
        :class="['dot', { active: activeIndex === i }]"
        type="button"
        :aria-label="`Go to slide ${i+1}`"
        @click="go(i)"
      />
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'ImageCarousel',
  components: { Carousel, Slide },
  props: ['images'],
  data() {
    return { activeIndex: 0 };
  },
  mounted() {
    // 초기 동기화 (안전하게 현재 페이지 읽어 반영)
    this.syncFromCarousel();
  },
  watch: {
    images() {
      // 이미지 배열이 바뀌면 인덱스 정리
      this.activeIndex = 0;
      this.$nextTick(this.syncFromCarousel);
    }
  },
  methods: {
    go(i) {
      // 도트 클릭 → 슬라이드 이동 + 인덱스 동기화
      if (this.$refs.c && typeof this.$refs.c.goToPage === 'function') {
        this.$refs.c.goToPage(i);
      }
      this.activeIndex = i;
    },
    onPageChange(i) {
      // 스와이프/드래그로 페이지 바뀐 뒤 이벤트
      this.activeIndex = i;
    },
    onPageChangeStart(i) {
      // (선택) 시작 시점이 필요하면 사용
      // console.log('start to', i);
    },
    syncFromCarousel() {
      // ref로 현재 페이지를 읽어 state 반영 (라이브러리 버전별 안전 처리)
      const c = this.$refs.c;
      if (!c) return;
      // 일부 버전은 currentPage, 일부는 getCurrentPage 제공
      const idx = typeof c.getCurrentPage === 'function'
        ? c.getCurrentPage()
        : (typeof c.currentPage === 'number' ? c.currentPage : 0);
      this.activeIndex = idx || 0;
    }
  }
};
</script>

<style scoped>
.carousel-frame { position: relative; width: calc(100% + 16px); margin-left: 8px; touch-action: pan-y; box-sizing: border-box; }

/* 4:3 + max-height 350px */
.image-box { position: relative; width: 100%; aspect-ratio: 1/1.7; max-height: 352px; overflow: hidden;  }
.image-box img { width: 100%; height: 100%; object-fit: cover; display: block; }

/* 커스텀 도트 (이미지 내부 하단 중앙) */
.dots {
  position: absolute; left: 50%; bottom: 30px; transform: translateX(-50%);
  display: flex; gap: 8px; padding: 6px 10px;
  border-radius: 999px; z-index: 3;
}
.dot { width: 10px; height: 10px; border-radius: 50%; border: none; background: rgba(255,255,255,.7); cursor: pointer; transition: transform .2s, background .2s, opacity .2s; opacity: .9; }
.dot.active { background: rgba(0,0,0,.85); transform: scale(1.2); opacity: 1; }

.default-image {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/hospital/Banner.vue